import defaultColors from "./defaultColors.json";

// Type definition for field definition options
export interface FieldDefinitionOption {
  id?: string;
  label?: string;
  value?: string;
  color?: string | null;
  [key: string]: unknown; // Allow for additional properties
}

export function invertColor(hex: string) {
  if (hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex[0] && hex[1] && hex[2]) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  // invert color components
  const r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
    g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
    b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str: string, len?: number) {
  len = len || 2;
  const zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
}

export function transparentOffset(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (result && result[1] && result[2] && result[3]) {
    return `rgba(${parseInt(result[1], 16)}, ${parseInt(
      result[2],
      16,
    )}, ${parseInt(result[3], 16)}, 0.9)`;
  }

  return hex;
}

// Helper function to get available colors and select a good default
export const getColorForOption = (
  existingOptions: FieldDefinitionOption[] = [],
  currentColor?: string | null,
): { color: string; excludedColors: string[] } => {
  // Filter out null/undefined colors from existing options
  const usedColors = existingOptions
    .map((option) => option.color)
    .filter(
      (color): color is string =>
        color !== null && color !== undefined && typeof color === "string",
    );

  // If we have a current color, use it
  if (currentColor && typeof currentColor === "string") {
    return {
      color: currentColor,
      excludedColors: usedColors,
    };
  }

  // Find the first unused color from defaultColors
  const availableColor = defaultColors.colors.find(
    (color) => !usedColors.includes(color),
  );

  return {
    color: availableColor || defaultColors.colors[0] || "#3b82f6",
    excludedColors: usedColors,
  };
};
